var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "terminalInfo-supplys-btn-group" },
        [
          !_vm.disabled
            ? _c(
                "span",
                {
                  staticClass: "terminalInfo-supplys-btn",
                  staticStyle: { "margin-left": "10px" },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-plus", type: "text" },
                      on: {
                        click: function () {
                          return _vm.openModal()
                        },
                      },
                    },
                    [_vm._v("添加产品系列")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("TableList", {
            staticStyle: { "margin-top": "10px" },
            attrs: { disabled: _vm.disabled, data: _vm.details },
            on: {
              deleteItem: function (rowIndex) {
                return _vm.deleteItem(rowIndex)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            modalConfig: {
              visible: _vm.dialogVisible,
              title: "选择产品系列",
              showFooter: true,
              buttons: {
                sure: true,
                close: true,
              },
            },
          },
          on: { onOk: _vm.submitData, onClose: _vm.closeModal },
        },
        [
          _c("ProductLevel", {
            attrs: { selectKeys: _vm.selectKeys },
            on: {
              onSelect: function (value) {
                return _vm.onSelect(value)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }